<section class="resource-with-tabs">
  <mat-card-header>
    <mat-card-title>{{ getResourceLabel() | async }}</mat-card-title>
    <nav class="header-actionbar">
      @if (((viewConfig | async)?.Details | async)?.length > 0 && (resource | async) != null) {
        @if (!editEnabled && editAllowed) {
          <button mat-icon-button (click)="editClick()">
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (editEnabled) {
          <button
            mat-icon-button
            [@enterAnimation]="!editEnabled"
            class="mat-icon-button-primary-color"
            (click)="saveClick()"
          >
            <mat-icon>save</mat-icon>
          </button>
        }
        @if (editEnabled) {
          <button
            mat-icon-button
            [@enterAnimation]="!editEnabled"
            class="mat-icon-button-error-color"
            (click)="cancelClick()"
          >
            <mat-icon>undo</mat-icon>
          </button>
        }
        @if (allowTimeline | async) {
          <button mat-icon-button (click)="openTimeline($event)">
            <mat-icon>query_builder</mat-icon>
          </button>
        }
        @if (allowAdvancedDetail | async) {
          <button mat-icon-button (click)="toggleAdvancedDetail()" [class.enabled]="advancedDetail">
            <mat-icon>settings</mat-icon>
          </button>
        }
        @if (deleteAllowed) {
          <button mat-icon-button (click)="deleteClick()">
            <mat-icon>delete</mat-icon>
          </button>
        }
      }
      <button mat-icon-button class="close-icon" (click)="onCloseView.emit({RefreshActive: false})">
        <mat-icon>close</mat-icon>
      </button>
    </nav>
  </mat-card-header>
  <mat-card-content>
    <mat-card appearance="raised" class="inner-card">
      <div class="resource-detail my-container" [class.edit]="editEnabled">
        @if (loading) {
          <div class="loader">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
        }

        @if (waitSpinner) {
          <div class="wait-spinner">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
        }

        @if (((viewConfig | async)?.Details | async)?.length > 0 && (resource | async) != null) {
          <mat-form-field class="tabs-mobile">
            <mat-select [(ngModel)]="selectedTab">
              @for (tc of (viewConfig | async)?.Details | async; track tc; let i = $index) {
                <div>
                  @if ((tc?.Visible | async) == true && (tc?.HasChilds | async) == true) {
                    <mat-option [value]="i">{{ (tc?.Caption | async)?.Values }} </mat-option>
                  }
                </div>
              }
            </mat-select>
          </mat-form-field>
        }

        <div #detailtabs>
          @if (((viewConfig | async)?.Details | async)?.length > 0 && (resource | async) != null) {
            <mat-tab-group
              #tabGroup
              [selectedIndex]="selectedTab"
              (selectedTabChange)="onTabSelectedChange($event)"
            >
              @for (tc of (viewConfig | async)?.Details | async; track tc) {
                <div>
                  @if ((tc?.Visible | async) == true && (tc?.HasChilds | async) == true) {
                    <mat-tab class="box" [disabled]="!(tc?.Enabled | async)">
                      <ng-template mat-tab-label>
                        <div class="label-container">
                          <i class="material-icons">error</i>
                          <span>{{ (tc?.Caption | async)?.Values }}</span>
                        </div>
                      </ng-template>
                      <mat-card-content>
                        <viewtab
                          [controls]="tc?.Controls"
                          [objectType]="(viewConfig | async)?.ObjectType"
                          [editEnabled]="editEnabled"
                          [freshResource]="freshResource"
                          [objectID]="(resource | async)?.ObjectID?.Values"
                          [objectDisplayName]="(resource | async)?.DisplayName?.Values"
                          [resource]="resource | async"
                          (onAddView)="onAddView.emit($event)"
                          (onUpdateResource)="updateResource($event)"
                          (onUpdateLocalizedValue)="updateLocalizedValue($event)"
                          (onUpdateLocale)="updateLocale($event)"
                          (onUpdateValidity)="updateValidity()"
                          #view
                        ></viewtab>
                      </mat-card-content>
                    </mat-tab>
                  }
                </div>
              }
            </mat-tab-group>
          }
        </div>
        @if (!loading && (noTabVisible() | async)) {
          <div class="detailErrors alert alert-warning" role="alert">
            <language
              key="ResourceDetailNoTabsVisible"
              defaultValue="There are no visible tabs in this view."
            ></language>
          </div>
        }
        @if (!loading && (noDialogConf() | async)) {
          <div class="detailErrors errorWithButton">
            <div class="alert alert-warning" role="alert">
              <language
                key="ResourceDetailNoDialogConf"
                defaultValue="Dialog Configuration not found."
              ></language>
            </div>
            @if (allowTimeline | async) {
              <button mat-icon-button (click)="openTimeline($event)">
                <mat-icon>query_builder</mat-icon>
              </button>
            }
            @if (allowAdvancedDetail | async) {
              <button
                mat-icon-button
                (click)="toggleAdvancedDetail()"
                [class.enabled]="advancedDetail"
              >
                <mat-icon>settings</mat-icon>
              </button>
            }
          </div>
        }
      </div>
    </mat-card>
    <button
      class="btn-scroll-top"
      mat-icon-button
      (click)="scrollTop()"
      [matTooltip]="scrollTopText | async"
    >
      <mat-icon>arrow_upward</mat-icon>
    </button>
  </mat-card-content>
</section>
